export default __webpack_public_path__ + "static/media/clinica_einstein.34b8c5a1.jpg";